import {useParams} from 'react-router-dom';

import {ModuleEnum, PermissionOperationEnum} from 'src/api/ProactApiClient';
import {ContentWrapper} from 'src/app/layout/ContentWrapper';

import {RiskAssessmentForm} from 'src/app/risk-assessment-code/RiskAssessmentCodeForm/RiskAssessmentForm';
import {routeRegistry} from 'src/pages/RouteRegistry';
import {PathUtility} from 'src/shared/constants/PathBuilder';

const ViewRiskAssessmentCodePage = () => {
  const {riskAssessmentId, view} = useParams();

  return (
    <ContentWrapper>
      <RiskAssessmentForm id={+riskAssessmentId!} mode="view" view={view} />
    </ContentWrapper>
  );
};

// Register the route with the new system
routeRegistry.registerPageRoute({
  backNavigation: 'page',
  path: PathUtility.RiskAssessmentView(':riskAssessmentId', ':view'),
  element: <ViewRiskAssessmentCodePage />,
  module: ModuleEnum.RiskAssessmentCodes,
  operation: PermissionOperationEnum.View,
  isPrivate: true,
});

export default ViewRiskAssessmentCodePage;
